export default {
    bindings: {
        'customerId': '@',
        'customerEmail': '@',
    },
    controller: 'accountPasswordController',
    template: require('../views/account.password.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/user/components/account.password.component.js